import React, { useEffect } from "react";
import "./Blog_outer_tab_Posts.css";
import { useDispatch, useSelector } from "react-redux";
import { gettopstatus } from "../../../../features/blog/Slice";

const Blog_outer_tab_Posts = () => {

  const toppost = useSelector((state)=> state.blog.addTopstatus);
  const dispatch = useDispatch();

  useEffect(()=>{
    dispatch(gettopstatus());
  }, [dispatch]);


  const posts = [
    { id: 1, title: "Limited-Time Deals You Don’t Want to Miss!" },
    { id: 2, title: "Everything You Need to Know About Our Hassle-Free Returns" },
    { id: 3, title: "How We’re Making Our Products More Eco-Friendly" },
    { id: 4, title: "How We’re Making Our Products More Eco-Friendly" },
    { id: 5, title: "Everything You Need to Know About Our Hassle-Free Returns" },
  ];

  return (
    <section className="Blog_outer_tab Blog_outer_tab_Posts">
      <div className="categories-container">
        <h3 className="categories-title">Top Posts</h3>
        <ul className="categories-list">
          {toppost.map((post) => (
            <li key={post.id}>
              <div className="list_text_holder">
                <div className="number_holder_main">
                  <div className="number_holder">
                    <h4>{post.id.toString().padStart(2, "0")}</h4>
                  </div>
                </div>
                <p>{post.name}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Blog_outer_tab_Posts;
